export class NoPagePaginationError extends Error {
    constructor(kind: "next" | "previous") {
        super(`No ${kind} page found in paginated response`);
        Object.setPrototypeOf(this, NoPagePaginationError.prototype);
    }
}
